import { ExtractedQuestionsCard } from './ExtractedQuestionsCard'

// Map of result_schema identifiers (declared on the C# tool definition) to the
// React component that knows how to render the result. When IterationGroup
// sees a tool with a known schema, it picks the component out of this map and
// renders it (with `streaming` while waiting for `result`, then with the
// populated `result` once the tool's complete event arrives).

import type { ToolTemplateProps } from '../../types'

export type ToolTemplate = (props: ToolTemplateProps) => JSX.Element | null

export const TOOL_TEMPLATES: Record<string, ToolTemplate> = {
  extract_questions_list: ExtractedQuestionsCard,
}
